import { ScreenHeader } from "@/components/ui/ScreenHeader";
import { Pill } from "@/components/ui/Pill";
import { Stack } from "expo-router";
import { Linking } from "react-native";
import { SUPPORT_EMAIL } from "@/constants";

export default function OTPVerificationLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: true,
        header: (props) => (
          <ScreenHeader
            title="auth.otp.headerTitle"
            {...props}
            options={{
              ...props.options,
              headerRight: () => (
                <Pill
                  label="auth.otp.getHelp"
                  variant="contact"
                  onPress={() => Linking.openURL(`mailto:${SUPPORT_EMAIL}`)}
                />
              ),
            }}
          />
        ),
      }}
    />
  );
}
